// extracted by mini-css-extract-plugin
export default {"password":"UserResetPassword_password__qFMmf","button":"UserResetPassword_button__Z59zw"};